import React from 'react';
import { 
  Clock, 
  CheckCircle, 
  Package, 
  XCircle,
  Truck
} from 'lucide-react';

const StatusBadge = ({ 
  status, 
  size = 'md',
  showIcon = true,
  className = '' 
}) => {
  const configs = {
    pendiente: {
      label: 'Pendiente',
      icon: Clock,
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      border: 'border-amber-200',
      iconColor: 'text-amber-500',
    },
    confirmado: {
      label: 'Confirmado',
      icon: CheckCircle,
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      border: 'border-blue-200',
      iconColor: 'text-blue-500',
    },
    en_camino: {
      label: 'En Camino',
      icon: Truck,
      bg: 'bg-indigo-50',
      text: 'text-indigo-700',
      border: 'border-indigo-200',
      iconColor: 'text-indigo-500',
    },
    entregado: {
      label: 'Entregado',
      icon: Package,
      bg: 'bg-green-50',
      text: 'text-green-700',
      border: 'border-green-200',
      iconColor: 'text-green-500',
    },
    cancelado: {
      label: 'Cancelado',
      icon: XCircle,
      bg: 'bg-red-50',
      text: 'text-red-700',
      border: 'border-red-200',
      iconColor: 'text-red-500',
    },
  };

  const config = configs[status] || configs.pendiente;
  const Icon = config.icon;

  const sizes = {
    sm: 'px-2 py-1 text-xs gap-1',
    md: 'px-3 py-1.5 text-sm gap-1.5',
    lg: 'px-4 py-2 text-base gap-2',
  };

  const iconSizes = {
    sm: 12,
    md: 14,
    lg: 18,
  };

  return (
    <span
      className={`
        inline-flex items-center
        font-semibold font-display
        rounded-full
        border
        ${sizes[size]}
        ${config.bg}
        ${config.text}
        ${config.border}
        ${className}
      `}
    >
      {showIcon && (
        <Icon 
          size={iconSizes[size]} 
          className={config.iconColor}
        />
      )}
      {config.label}
    </span>
  );
};

export default StatusBadge;
